import React from "react";
import { Card, Tabs } from "antd";
import "./CardWithTabs.css";

const { TabPane } = Tabs;

const CardWithTabs = ({
  tabList,
  activeTabKey,
  onTabChange,
  nestedTabList,
  nestedActiveKey,
  onNestedTabChange,
  children,
  cardId,
}) => {
  return (
    <Card
      bordered={true}
      tabList={tabList}
      activeTabKey={activeTabKey}
      onTabChange={onTabChange}
      className="card-container custom-nested-tabs"
      id={cardId}
    >
      {children}
      {activeTabKey === "reporting" && nestedTabList && (
        <div className="custom-tabs-wrapper">
          <Tabs
            activeKey={nestedActiveKey}
            onChange={onNestedTabChange}
            size="small"
            id="nested-tabs"
            className="custom-nested-tabs"
          >
            {nestedTabList.map((tab) => (
              <TabPane
                key={tab.key}
                tab={<span className="custom-tab-label">{tab.tab}</span>}
                className="custom-tab-pane"
              >
                {tab.content}
              </TabPane>
            ))}
          </Tabs>
        </div>
      )}
    </Card>
  );
};

export default CardWithTabs;
